module.exports = __webpack_public_path__ + "img/spain-tuberculosis-male.6e39efd7.png";